import { ParamsToCrateFinancialAdjustment } from '@/modules/financialAdjustment/entities/financialAdjustment.interface';

export const PARAMS_FROM_FORM_INITIAL_STATE: ParamsToCrateFinancialAdjustment = {
  contractId: '',
  description: '',
  portionType: '',
  date: '',
  value: 0,
};
